<div class="preview-container">
  @if (data) {
  <div class="dialog-header">
    <h2 class="dialog-title">Match preview for {{ task.orderId }}</h2>
  </div>
  <div class="count">
    <p>
      <strong> Total:</strong>
      {{ data.resultCountStats['TOTAL'] }}
      results
    </p>
    @if (hasResultCountKey('TRADEMARK')) {
    <p>
      <strong>Trademarks: </strong
      >{{ data.resultCountStats['TRADEMARK'] }} results
    </p>
    } @if (hasResultCountKey('POCA') && hasPreviewShowPocaCount()) {
    <p><strong>POCA: </strong>{{ data.resultCountStats['POCA'] }} results</p>
    }
  </div>
  <div class="table-wrapper">
    <table mat-table [dataSource]="dataSource">
      <ng-container matColumnDef="match">
        <th mat-header-cell *matHeaderCellDef sticky>Match</th>
        <td mat-cell *matCellDef="let element">{{ element.match }}</td>
      </ng-container>
      <ng-container matColumnDef="count">
        <th mat-header-cell *matHeaderCellDef sticky>Total</th>
        <td mat-cell *matCellDef="let element">{{ element.count }}</td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="['match', 'count']"></tr>
      <tr mat-row *matRowDef="let row; columns: ['match', 'count']"></tr>
    </table>
  </div>
  }
</div>
